import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/memberships',
  component: Management,
  redirect: '/memberships/detail',
  children: [
    // 详情页
    {
      path: 'detail',
      component: () => import('@/views/memberships/DetailLayout'),
      redirect: 'detail/membership',
      meta: {
        auth: Auth.showMembership
      },
      children: [
        //会员信息
        {
          path: 'membership',
          component: () => import('@/views/memberships/details/Detail'),
          meta: {
            auth: Auth.showMembership,
            tabName: 'membership'
          }
        },
        {
          path: 'vip_members',
          component: () => import('@/views/memberships/details/VipMembers'),
          redirect: 'vip_members/all',
          meta: {
            auth: Auth.listVipMembers,
            tabName: 'vip_members'
          },
          children: [
            {
              path: 'all',
              component: () => import('@/views/vip_members/ListTable'),
              meta: {
                auth: Auth.listVipMembers,
                tabName: 'all'
              }
            },
            {
              path: 'active',
              component: () => import('@/views/vip_members/ListTable'),
              meta: {
                auth: Auth.listVipMembers,
                tabName: 'active'
              }
            },
            {
              path: 'inactive',
              component: () => import('@/views/vip_members/ListTable'),
              meta: {
                auth: Auth.listVipMembers,
                tabName: 'inactive'
              }
            }
          ]
        },
        {
          path: 'vip_charge_stations',
          component: () => import('@/views/memberships/details/VipChargeStations'),
          meta: {
            auth: Auth.listVipChargeStations,
            tabName: 'vip_charge_stations'
          }
        },
        {
          path: 'orders',
          component: () => import('@/views/memberships/details/Orders'),
          meta: {
            auth: Auth.showMembership,
            tabName: 'orders'
          }
        }
      ]
    },
    //编辑页
    {
      path: 'edit',
      component: () => import('@/views/memberships/Edit'),
      meta: {
        auth: Auth.updateMembership,
        tabName: 'edit'
      }
    }
  ]
}
